import type { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from './auth-store';
import { useProjectStore } from '../project/project-store';
import { logoutRequest } from './auth-api';

/**
 * Log out: best-effort server revoke, then clear ALL client-side state.
 *
 * The TanStack Query cache MUST be cleared too (FE-B2) — otherwise the next
 * user to log in on the same tab briefly sees the previous user's cached
 * `['projects','list']`, `['admin-users']`, etc. before refetches land.
 */
export async function performLogout(queryClient: QueryClient): Promise<void> {
  try {
    await logoutRequest();
  } catch {
    // best-effort; clear local state regardless
  }
  useAuthStore.getState().clear();
  useProjectStore.getState().clear();
  queryClient.clear();
}
